import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';
import { TwitterShareButton } from 'react-twitter-embed';
import MarqueeBanner from '../MarqueeBanner/MarqueeBanner';
import { auth } from '../../firebase';

export default function Footer() {
  const navigate = useNavigate();
  const isLoggedIn = auth.currentUser != null && auth.currentUser !== undefined;

  return (
    <footer className="footer_whole_home">
      <MarqueeBanner />
      <div className="footer__content">
        <div className="footer__brand-wrap">
          <button type="button" className="footer__brand" onClick={() => navigate(isLoggedIn ? '/alternativehomepage' : '/')}>
            PREMSI
          </button>
        </div>
        <nav className="footer__nav">
          <a onClick={() => navigate('/faq')}>faq</a>
          <a onClick={() => navigate('/communityguidelines')}>community guidelines</a>
          {/*<a onClick={() => navigate('/presentation')}>presentation</a>*/}
          <a onClick={() => navigate('/ambassador')}>ambassador program</a>
          <a onClick={() => navigate('/explanation')}>how to use</a>
          <a onClick={() => navigate('/calculator')}>$ calculator</a>
          <a onClick={() => navigate('/termsofservice')}>terms</a>
          <a onClick={() => navigate('/privacypolicy')}>privacy</a>
          <a href="mailto:contact@premsi.com">contact</a>
        </nav>
        <div className="footer__bottom">
          <div className="footer__stores">
            <a href="https://play.google.com/store/apps/details?id=com.Premsi.app" target="_blank" rel="noopener noreferrer" className="footer__store-link footer__store-link--play">
              <img loading="lazy" src={require('../../images/googleplay.webp')} alt="GET IT ON Google Play" height={40} />
            </a>
            <a href="https://apps.apple.com/app/apple-store/id6446628909" target="_blank" rel="noopener noreferrer" className="footer__store-link">
              <img loading="lazy" src={require('../../images/appstore.webp')} alt="Download on the App Store" height={40} />
            </a>
          </div>
          <div className="footer__socials">
            <a href="https://www.instagram.com/premsicom" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <img loading="lazy" alt="" width={24} height={24} src={require('../../images/socialicons/instalogo.webp')} />
            </a>
            <a href="https://www.twitter.com/PremsiCom" target="_blank" rel="noopener noreferrer" aria-label="X">
              <img loading="lazy" alt="" width={24} height={24} src={require('../../images/socialicons/twitter.webp')} />
            </a>
            <TwitterShareButton
              onLoad={function noRefCheck() {}}
              options={{
                size: 'large',
                text: 'Have a look at Premsi: The most monetizable social media App 🔥',
                url: 'https://www.premsi.com/',
              }}
              placeholder={<span className="footer__x-placeholder">X Post</span>}
              url="https://www.premsi.com/"
            />
          </div>
          <div className="footer__copy">
            <img loading="lazy" src={require('../../images/pblue-min.webp')} alt="Premsi" className="footer__copy-logo" />
            <span>© Premsi 2025</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
